var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg41 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "41")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M84.79,44.82c-.35-22.19-18.45-39.41-41-39C22.76,6.11,5,24.36,5.31,45.24c.38,23.26,17.93,40.33,41.11,40C67.72,84.92,85.13,66.58,84.79,44.82ZM45.28,77.43c-17.48.24-32-14.17-32.13-32C13,28.22,27.49,13.66,44.93,13.57A32.13,32.13,0,0,1,77,45.64C77,62.82,62.72,77.19,45.28,77.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.21,45.37a23.86,23.86,0,0,1,47.71.25C69,58.5,58.19,69.31,45.14,69.36A23.85,23.85,0,0,1,21.21,45.37Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg41, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/41.ef635092.svg";
export { ForwardRef as ReactComponent };